import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 flex flex-col justify-between items-center" }
const _hoisted_2 = { class: "text-6xl font-bold text-white flex justify-center px-6 pb-3 bg-gray-900 bg-opacity-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)

import { IPair } from '../interfaces'

export default /*#__PURE__*/_defineComponent({
  props: {
    pairA: null,
    pairB: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.pairA.point), 1),
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(__props.pairB.point), 1)
    ])
  ]))
}
}

})